import { TFunction } from 'core/i18n/i18n';

export const getCustomMessages = (t: TFunction) => ({
    mandatory: {
        ldapField: {
            warning: {
                mapping: t(
                    'settings.integrations.active-directory.data-points.mapping.ldap.mandatory.warning.non-exist'
                ),
            },
        },
    },
    optional: {
        ldapField: {
            warning: {
                mapping: t(
                    'settings.integrations.active-directory.data-points.mapping.ldap.optional.warning.non-exist'
                ),
            },
        },
        pocField: {
            warning: {
                'non-exist': t(
                    'settings.integrations.active-directory.data-points.mapping.poc.optional.warning.non-exist'
                ),
            },
        },
    },
});
